import styled from 'styled-components'
import { baseTheme } from 'primsell-shared-layer/styles/theme'

export const ExpPaymentTimerBox = styled.div<{ center?: boolean }>`
  display: flex;
  justify-content: ${(props) => (props.center ? 'center' : 'space-between')};
  max-width: 1100px;
  margin-bottom: 40px;

  background: ${baseTheme.colors.white};
  padding: 0px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.1);

  @media screen and (max-width: 560px), @media ${baseTheme.device.mobileL} {
    flex-direction: column;
    background: ${baseTheme.colors.white};
    margin-top: 0px;
    margin: 8px 16px;
  }

  @media screen and (max-width: 560px), @media ${baseTheme.device.mobileL} {
    border-radius: 16px;
    background: #f9fafb;
  }

  @media ${baseTheme.device.tablet} {
    border-radius: 16px;
  }
`

export const ExpPaymentTimerContainerLeft = styled.div`
  padding: 21px 38px;
  display: block;

  span {
    display: inline-block;
    font-family: 'Inter';
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
  }

  @media screen and (max-width: 560px), @media ${baseTheme.device.mobileL} {
    text-align: center;
    padding: 16px 8px;
    width: 100%;

    span {
      display: block;
      font-size: 14px;
      line-height: 16px;
    }
  }
`

export const ExpPaymentTimerContainerRight = styled.div`
  border-left: none;
  border-top: 2px dashed #e5e7eb;
  padding: 21px 38px;
  text-align: right;

  span {
    font-family: 'Inter';
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
  }

  @media screen and (max-width: 560px) {
    border-top-style: solid;
    text-align: center;
    padding: 16px 8px;

    span {
      font-size: 14px;
    }
  }

  @media ${baseTheme.device.tablet} {
    border-left: 2px dashed #e5e7eb;
    border-top: none;
  }
`

export const ExpPaymentTimer = styled.span<{ warning?: boolean }>`
  color: ${(props) => (props.warning ? '#9b1c1c' : '#28252d')};
`
